import { Rule } from 'antd/es/form';
// Helpers
import {
  STREAM_DISCOUNT_PERCENTS,
  isStreamDiscountAllowed,
} from './discont-amount-helpers';

type DataType = {
  required?: boolean;
  message: string;
};

export const formItemRules = {
  name: [
    {
      required: true,
      message: 'Please enter the name of the promo code',
    },
  ],
  startDate: [
    {
      required: true,
      message: 'Please enter the start date of the promo code',
    },
  ],
  validityPeriod: [
    {
      required: true,
      message: 'Please enter the start and end date of the promo code',
    },
  ],
  timeZone: [
    {
      required: true,
      message: 'Please select time zone.',
    },
  ],
  amount(requiresStreamPreset: boolean): Rule[] {
    return [
      {
        required: true,
        message: requiresStreamPreset
          ? 'Please pick one of the stream discounts'
          : 'Please enter the amount of discount',
      },
      {
        validator: (_, value) =>
          !requiresStreamPreset ||
          value == null ||
          isStreamDiscountAllowed(value)
            ? Promise.resolve()
            : Promise.reject(
                new Error(
                  `Stream discounts must be one of ${STREAM_DISCOUNT_PERCENTS.join(
                    '%, '
                  )}%`
                )
              ),
      },
    ];
  },
  limitations(required?: boolean): DataType[] {
    return [
      {
        required,
        message: 'Please enter the limit of usage',
      },
    ];
  },
  usagePerUser(required?: boolean): DataType[] {
    return [
      {
        required,
        message: 'Please enter the limit of usage per user',
      },
    ];
  },
  chargeSubject: [
    {
      message: 'Please enter the name of the promo code',
    },
  ],
  siteWideData(required?: boolean): DataType[] {
    return [
      {
        required,
        message: 'Please select a product from the list',
      },
    ];
  },
};
